export default __webpack_public_path__ + "static/media/img-0050.9c5a9104.png";